import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useAccount } from 'wagmi'
import { IPFStoURL, getCurrentChain, getWeb3 } from '../helper/functions';
import { CHAIN_INFO, SUPPORTED_CHAIN } from '../helper/constant';
import auctionAbi from '../abis/nftauction.json';
import nft1155Abi from '../abis/nft1155.json';
import { ethers } from 'ethers';
import { useToasts } from 'react-toast-notifications';
import { getContract } from '../helper/contractHelper';
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEthersSigner } from '../stats/useEthersSigner';
import { useSelector } from 'react-redux';

export default function CreateSaleModal({ show, setShow, nftData, metadata , setUpdater , stats  }) {
    const { chainId, address } = useAccount();
    const currentChainId = getCurrentChain(chainId);
    const [selectedCurrencyId, setSelectedCurrencyId] = useState(null);
    const [salePrice, setSalePrice] = useState('');
    const [saleamount, setSaleamount] = useState('');
    const { addToast, removeAllToasts } = useToasts();
    const signer = useEthersSigner({ chainId: currentChainId });
    const [isAuction, setIsAuction] = useState(false);
    const [endTime, setEndTime] = useState('');
    const [loading,setLoading] = useState(false);
    const theme = useSelector((state) => state.user.theme);



    const handleCreateSale = async () => {
        try {
            setLoading(true);
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let auctionContract = getContract(auctionAbi, CHAIN_INFO[chainId].nft_auction, signer);
                    let tx = await auctionContract.createSale(
                        isAuction ? '2' : '1',
                        nftData.type === 'ERC-1155' ? '2' : '1',
                        nftData.nft_address,
                        nftData.tokenId,
                        saleamount ? saleamount : 1,
                        ethers.utils.parseUnits(salePrice.toString() , CHAIN_INFO[currentChainId].currency_support[selectedCurrencyId].decimals),
                        isAuction ? Math.floor(new Date(endTime).getTime() / 1000.0) : 0,
                        CHAIN_INFO[currentChainId].currency_support[selectedCurrencyId].address,
                        { 'from': address });

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(currentChainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                        }
                    }, 5000);
                } else {
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                    setLoading(false);
                }
            } else {
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
                setLoading(false);
            }
        } catch (err) {
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            console.error(err.message);
            setLoading(false);
        }
    }

    const handleApprove = async () => {
        try {
            setLoading(true);
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let nftContract = getContract(nft1155Abi, nftData.nft_address, signer);
                    let tx = await nftContract.setApprovalForAll(CHAIN_INFO[chainId].nft_auction, true, { 'from': address });

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(currentChainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });
                                setUpdater(Math.random());
                                setLoading(false);
                            }
                        }
                    }, 5000);
                } else {
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                    setLoading(false);
                }
            } else {
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
                setLoading(false);
            }
        } catch (err) {
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            setLoading(false);
            console.error(err.message);
        }
    }


    return (
        <>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className={`${theme}-scheme p-4`}
            >
                <Modal.Body >
                    <div className='d-flex justify-content-between'>
                        <h3>Create Sale</h3>
                        <button onClick={() => setShow(false)} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className='row d-flex justify-content-center mb-3'>
                        <div className='col-3'>
                            <img src={IPFStoURL(metadata?.['image'])} class="img-rounded mb-sm-30" height="100px" width="100px" alt="profile" />
                        </div>
                        <div className='col-5'>
                            <h5>{metadata?.['name']}</h5>
                            <h5>Token ID : {nftData && nftData.tokenId ? nftData.tokenId : ''}</h5>
                        </div>
                    </div>
                    <div class="p-3 form-border">

                        <div className='row'>
                            {nftData.type === 'ERC-1155' &&
                                <>
                                    <div className='col-12 col-md-7'>
                                        <h6># of items</h6>
                                        <input type="text" onChange={(e) => setSaleamount(e.target.value)} name="sale_price" id="sale_price" class="form-control mb-0" value={saleamount} placeholder='Enter sale price' />
                                        <span>Balance : {stats.balance ? stats.balance : 0}</span>
                                    </div>
                                    <div class="spacer-20"></div>
                                </>
                            }
                            <div className='col-12 col-md-7'>
                                <h6>Sale Price</h6>
                                <input type="text" onChange={(e) => setSalePrice(e.target.value)} name="sale_price" id="sale_price" class="form-control" value={salePrice} placeholder='Enter sale price' />
                            </div>
                            <div className='col-12 col-md-5'>
                                <h6>Select Curency</h6>
                                <select className='form-control' name="currency" onChange={(e) => setSelectedCurrencyId(e.target.value)}>
                                    <option selected>Select Currency</option>
                                    {CHAIN_INFO[currentChainId] && CHAIN_INFO[currentChainId].currency_support && CHAIN_INFO[currentChainId].currency_support.map((items, key) => {
                                        return (
                                            <option selected={key === selectedCurrencyId} value={key}>
                                                {items.name}{" "}({items.symbol})
                                            </option>
                                        )
                                    })}

                                </select>
                            </div>
                            <div class="spacer-20"></div>
                            <div className='col-12'>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch"
                                    label="Is Auction?"
                                    defaultChecked={isAuction}
                                    checked={isAuction}
                                    onChange={() => setIsAuction(!isAuction)}
                                />
                            </div>
                            <div class="spacer-single"></div>
                            {
                                isAuction &&
                                <div className='col-12'>
                                    <h6>Set EndTime</h6>
                                    <DatePicker
                                        selected={endTime}
                                        onChange={(date) => setEndTime(date)}
                                        isClearable
                                        placeholderText="Select End Time!"
                                        minDate={new Date()}
                                        showDisabledMonthNavigation
                                        showTimeSelect
                                        dateFormat="MMMM d, yyyy h:mm aa"
                                    />
                                </div>
                            }
                        </div>
                        <div class="spacer-single"></div>
                        {stats.isApproved ? (
                            <button type="button" disabled={loading} onClick={() => handleCreateSale()} class="btn-main btn-fullwidth">
                                { loading ? 'Loading...' :  'Create Sale' }
                            </button>
                        ) : (
                            <button type="button" disabled={loading} onClick={() => handleApprove()} class="btn-main btn-fullwidth">
                                { loading ? 'Loading...' :  'Approve' }
                            </button>
                        )}

                    </div>
                </Modal.Body>

            </Modal>
        </>
    )
}
